import { Component } from "react";
import { connect } from "react-redux";

import { Icon } from "components/icon/Icon";
import { PrimaryArrowButton } from "components/button/Button";
import {
  emptyCommitments,
  setAssignmentManagerList
} from "views/invoices/Actions";
import AssignmentManagerList from "../AssignmentManagerList/AssignmentManagerList";
import AssignmentManagerCommitments from "../AssignmentManagerCommitments/AssignmentManagerCommitments";

import "./InvoiceReport.scss";

class InvoiceReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedManager: null
    };
  }

  changeAssignmentManager() {
    this.props.dispatch(setAssignmentManagerList([]));
    this.props.dispatch(emptyCommitments());
  }

  render() {
    const infoTable = (
      <div className="infoContainer">
        <table>
          <tbody>
            <tr>
              <td>
                <Icon
                  style={{ color: "red" }}
                  name="flag"
                  title="Slutfaktura"
                />
              </td>
              <td>
                <i>Slutfaktura</i>
              </td>
            </tr>
            <tr>
              <td>
                <Icon
                  style={{ color: "lightblue" }}
                  name="flag"
                  title="A conto"
                />
              </td>
              <td>
                <i>A conto</i>
              </td>
            </tr>
            <tr>
              <td>
                <div className="isAnomaly" title="Ovanligt stor ändring" />
              </td>
              <td>
                <i>Ovanligt stor ändring (+30% jämfört med f.g. år)</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );

    return (
      <div className="wrapper">
        {this.state.selectedManager && (
          <>
            <div className="header">
              <h3 className={"m-0"}>
                {this.state.selectedManager.name} -{" "}
                {this.state.selectedManager.id}
              </h3>

              <PrimaryArrowButton
                onClick={() => {
                  this.setState({ selectedManager: null });
                }}
              >
                Byt uppdragsansvarig
              </PrimaryArrowButton>
            </div>
            {infoTable}
          </>
        )}

        {!this.state.selectedManager && (
          <AssignmentManagerList
            onSelectManager={(manager) =>
              this.setState({ selectedManager: manager })
            }
          />
        )}

        {this.state.selectedManager && (
          <AssignmentManagerCommitments
            selectedAssignmentManager={this.state.selectedManager}
          />
        )}
      </div>
    );
  }
}

export default connect(() => {
  return {};
})(InvoiceReport);
